import { render } from "./GiftCardRedirectNotice.vue?vue&type=template&id=0ad37be7&scoped=true"
import script from "./GiftCardRedirectNotice.vue?vue&type=script&lang=js"
export * from "./GiftCardRedirectNotice.vue?vue&type=script&lang=js"

import "./GiftCardRedirectNotice.vue?vue&type=style&index=0&id=0ad37be7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad37be7"]])

export default __exports__